<div *transloco="let t">
  <div class="my-0 pt-2">
    <div class="flex flex-col gap-3">
      @if (strategy(); as strategy) {
        @if (!strategy.disableOtherQueries) {
          <app-sd-targeting
            [defaultTactic]="true"
            [strategy]="strategy"
            [isReadOnly]="isReadOnly()"
            [isLastTargeting]="isOnlyOneTargeting()"
            [organizationId]="organizationId()"
          ></app-sd-targeting>
        }
        @for (tactic of targetings(); track tactic) {
          <app-sd-targeting
            [tactic]="tactic"
            [strategy]="strategy"
            [isReadOnly]="isReadOnly()"
            [isLastTargeting]="isOnlyOneTargeting()"
            [organizationId]="organizationId()"
          ></app-sd-targeting>
        }
        @for (audience of audiences(); track audience) {
          <app-sd-targeting
            [audience]="audience"
            [strategy]="strategy"
            [isReadOnly]="isReadOnly()"
            [isLastTargeting]="isOnlyOneTargeting()"
            [organizationId]="organizationId()"
          ></app-sd-targeting>
        }
        <button
          iButton
          variant="secondary"
          [disabled]="isReadOnly() || isTargetingCountReached()"
          (click)="createTargeting()"
          [iTooltip]="isTargetingCountReached() && t('sd-targeting.maximum_targetings_reached')"
          iTooltipPlacement="top-center"
        >
          <IIcon name="plus" />
          {{ t("sd-page.add_a_targeting") }}
        </button>
      }
    </div>
  </div>
</div>
